export default __webpack_public_path__ + "static/media/a1.69ca3ad2.png";